export const SUMMARY_REPORT = {
    CLOSE_MESSAGE: 'SUMMARY_REPORT_CLOSE_MESSAGE',
    RELOAD: 'SUMMARY_REPORT_RELOAD',
    EXECUTING: 'SUMMARY_REPORT_EXECUTING',
    ON_SUMMARY_FETCHED: 'SUMMARY_REPORT_ON_REPORT_FETCHED',
    ON_CONFIRMED: 'SUMMARY_REPORT_ON_CONFIRMED',
    ON_FAILED: 'SUMMARY_REPORT_ON_FAILED'
};
